import { map } from './map';
import { transform } from './transform';

export const ceil = transform(map, Math.ceil);
